import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { CompanyTypeListService } from '../../service/company-type-list/company-type-list.service';

@Component({
	selector: 'app-company-type-list',
	templateUrl: './company-type-list.component.html',
	providers: [
		CompanyTypeListService,
		HttpModule
	]
})
export class CompanyTypeListComponent implements OnInit {

	private token;
	public companyTypes: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Tipo";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	companyType: FormGroup;

	constructor(fb: FormBuilder, private companyTypeListService: CompanyTypeListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.companyType = fb.group({
			'Tipo': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchCompany(this.companyType.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchCompany(this.companyType.value, this.currentPage, false);
	}

	searchCompany(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Tipo";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.companyTypeListService.searchCompanyType(this.token, value.Tipo, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.companyTypes = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchCompany(this.companyType.value, $event, false);
	}

}


// WEBPACK FOOTER //
// ./src/app/company-type/component/company-type-list/company-type-list.component.ts